import { httpClient } from './http-client';

export interface FavoriteItem {
  id: string;
  doctorId: string;
  patientId: string;
  createdAt: string;
}

export interface FavoriteWithDoctor {
  id: string;
  doctorId: string;
  patientId: string;
  createdAt: string;
  doctor: {
    id: string;
    displayName: string | null;
    specialty: string;
    crm: string;
    crmState: string;
    photoUrl: string | null;
    rating: number;
  };
}

export const favoritesApi = {
  getFavorites: (): Promise<{ favorites: FavoriteWithDoctor[] }> =>
    httpClient.get<{ favorites: FavoriteWithDoctor[] }>('/favorites'),

  addFavorite: (doctorId: string): Promise<{ favorite: FavoriteItem }> =>
    httpClient.post<{ favorite: FavoriteItem }>('/favorites', { doctorId }),

  removeFavorite: (doctorId: string): Promise<void> =>
    httpClient.delete<void>(`/favorites/${doctorId}`),

  isFavorite: (doctorId: string): Promise<boolean> =>
    httpClient.get<boolean>(`/favorites/${doctorId}/check`),
};
